(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyRangeSpinner", [
    "DebugLogger",
    "Range",
    "$parse",
    "$analytics",
    function (DebugLogger, Range, $parse) {
      var controller = [
        "$scope",
        "$attrs",
        "RangePaintApi",
        "$analytics",
        "Location",
        "$element",
        "Tfy",
        function (
          $scope,
          $attrs,
          RangePaintApi,
          $analytics,
          Location,
          $element,
          Tfy
        ) {
          var ctl = this;

          $scope.rangeSpinner = {
            grades: [],
            gradeId: null,
            allBodyPaints: [],
            allRoofPaints: [],
            currentBodyPaints: [],
            bodyPaintId: null,
            currentRoofPaints: [],
            roofPaintId: null,
            showRoofPaints: false,
            materialCode: null,
            savedBodyPaintId: null,
            savedRoofPaintId: null,
            pricingParams: {
              postcode: null,
            },
            isFirstPageLoad: true,
            isGradeUpdated: false,
          };
          var submitAnalyticTimeout = 300;
          function ingestGrades(rangeSpinnerGradeObject) {
            /*
             * This introduces a roofPaints array for each paint. As per the Range Spinner UI:
             *
             * 1. Every paint without a relatedPrimaryPaintId will contain a copy of itself under its own roofPaints array;
             * 2. Every paint with a relatedPrimaryPaintId is moved into the related paint's roofPaints array.
             *
             * Which gives us the two-level hierarchy of body paints -> roof paints we need for the UI.
             *
             * We also add a containsRoofPaints property for each grade.
             */

            return rangeSpinnerGradeObject.map(function (grade) {
              return angular.extend({}, grade, {
                containsRoofPaints: !!grade.paints.find(function (paint) {
                  return paint.relatedPrimaryPaintId;
                }),
                paints: grade.paints
                  .filter(function (paint) {
                    return !paint.relatedPrimaryPaintId;
                  })
                  .map(function (paint) {
                    return angular.extend({}, paint, {
                      id: "bodypaint-" + paint.id,
                      roofPaints: grade.paints.filter(function (roofPaint) {
                        return (
                          roofPaint.id === paint.id ||
                          roofPaint.relatedPrimaryPaintId === paint.id
                        );
                      }),
                    });
                  }),
              });
            });
          }

          function init() {
            var grades = ingestGrades(
              angular.fromJson($attrs.tyRangeSpinnerGradeObject)
            );

            $scope.rangeSpinner.grades = grades;
            $scope.rangeSpinner.allBodyPaints = grades.reduce(function (
              bodyPaints,
              grade
            ) {
              return bodyPaints.concat(grade.paints);
            },
            []);
            $scope.rangeSpinner.allRoofPaints =
              $scope.rangeSpinner.allBodyPaints.reduce(function (
                roofPaints,
                bodyPaint
              ) {
                return roofPaints.concat(bodyPaint.roofPaints);
              },
              []);

            $scope.rangeSpinner.geolocateSearchChildOpenedModal = false;

            $scope.$on(
              "geo-locate-search-click",
              function (event, $geoLocateSearch) {
                if ($geoLocateSearch.parents($element).length > 0) {
                  $scope.rangeSpinner.geolocateSearchChildOpenedModal = true;
                }
              }
            );

            $scope.$on("did-modal-close", function (event, modalId) {
              if (modalId !== "change-location") {
                return;
              }

              $scope.rangeSpinner.geolocateSearchChildOpenedModal = false;
            });

            $scope.$on("GeoPostCode", function (event, postcode) {
              DebugLogger.log(
                "tyRangeSpinner",
                "Changing driveawayPrice.postcode to",
                postcode
              );

              $scope.driveawayPrice.fetchPrice().finally(function () {
                triggerOnLoadedHandlerIfLoadingComplete();
              });
              $scope.rangeSpinner.pricingParams.postcode = postcode;
            });

            $scope.rangeSpinner.pricingParams.postcode =
              Location.get().postcode;
          }

          ctl.$onInit = init;

          function getBodyPaintById(bodyPaintId) {
            return $scope.rangeSpinner.allBodyPaints.find(function (bodyPaint) {
              return bodyPaint.id === bodyPaintId;
            });
          }

          function getRoofPaintsByBodyPaintId(bodyPaintId) {
            var bodyPaint = getBodyPaintById(bodyPaintId);
            return bodyPaint ? bodyPaint.roofPaints : [];
          }

          function getRoofPaintById(roofPaintId) {
            var roofPaintMatches = $scope.rangeSpinner.allRoofPaints.filter(
              function (roofPaint) {
                return roofPaint.id === roofPaintId;
              }
            );
            return roofPaintMatches.length ? roofPaintMatches[0] : null;
          }

          function updateBodyPaints(newBodyPaints) {
            DebugLogger.log(
              "tyRangeSpinner",
              "currentBodyPaints changing to",
              newBodyPaints
            );
            $scope.rangeSpinner.currentBodyPaints = newBodyPaints;
            DebugLogger.log(
              "tyRangeSpinner",
              "currentBodyPaints changed to",
              newBodyPaints
            );

            var bodyPaintId = newBodyPaints.length ? newBodyPaints[0].id : null;
            var targetBodyPaintId =
              $scope.rangeSpinner.savedBodyPaintId ||
              $scope.rangeSpinner.bodyPaintId;

            if (!targetBodyPaintId) {
              DebugLogger.log(
                "tyRangeSpinner",
                "Changing bodyPaintId to",
                bodyPaintId
              );
              ctl.setBodyPaintById(bodyPaintId);

              return;
            }

            var targetBodyPaint = getBodyPaintById(targetBodyPaintId);

            if (newBodyPaints.length && targetBodyPaint) {
              bodyPaintId = RangePaintApi.getClosestBodyPaint(
                targetBodyPaint.name,
                targetBodyPaint.hexCode,
                newBodyPaints,
                RangePaintApi.schemas.rangeSpinner
              ).id;
            }

            DebugLogger.log(
              "tyRangeSpinner",
              "Changing bodyPaintId to",
              bodyPaintId
            );
            ctl.setBodyPaintById(bodyPaintId);
          }

          function updateRoofPaints(newRoofPaints) {
            DebugLogger.log(
              "tyRangeSpinner",
              "roofPaints changing to",
              newRoofPaints
            );
            $scope.rangeSpinner.currentRoofPaints = newRoofPaints;
            $scope.rangeSpinner.showRoofPaints =
              $scope.rangeSpinner.grade.containsRoofPaints;
            DebugLogger.log(
              "tyRangeSpinner",
              "roofPaints changed to",
              newRoofPaints
            );

            var targetRoofPaintId =
              $scope.rangeSpinner.savedRoofPaintId ||
              $scope.rangeSpinner.roofPaintId;
            var roofPaintId = newRoofPaints.length ? newRoofPaints[0].id : null;

            function updateSelectedRoofPaint() {
              DebugLogger.log(
                "tyRangeSpinner",
                "Changing selectedRoofPaintId to",
                roofPaintId
              );
              ctl.setRoofPaintById(roofPaintId);

              if (!roofPaintId) {
                return;
              }

              var roofPaint = getRoofPaintById(roofPaintId);
              if (
                $scope.rangeSpinner.showRoofPaints &&
                !$scope.rangeSpinner.isGradeUpdated
              ) {
                triggerRoofPaintPassiveSelectionAnalyticsEvent(roofPaint.name);
              }

              $scope.rangeSpinner.isFirstPageLoad = false;
            }

            if (!targetRoofPaintId) {
              updateSelectedRoofPaint();
              return;
            }

            var targetRoofPaint =
              Range.getRoofPaintByIdFromCache(targetRoofPaintId);
            if (newRoofPaints.length && targetRoofPaint) {
              roofPaintId = RangePaintApi.getClosestRoofPaint(
                targetRoofPaint.name,
                newRoofPaints,
                RangePaintApi.schemas.rangeSpinner
              ).id;
            }

            updateSelectedRoofPaint();
          }

          var analyticEvents = [];

          function triggerRoofPaintPassiveSelectionAnalyticsEvent(
            roofPaintDescription
          ) {
            if ($scope.rangeSpinner.isFirstPageLoad) {
              return;
            }

            analyticEvents.push({
              event: "selectRoofPaint",
              description: roofPaintDescription,
            });

            setTimeout(function () {
              var uniqueDescriptions = new Set();

              // Filter out duplicates based on the 'description' property
              var uniqueEvents = analyticEvents.filter(function (event) {
                if (!uniqueDescriptions.has(event.description)) {
                  uniqueDescriptions.add(event.description);
                  return true;
                }

                return false;
              });

              if (Number(window.PageLoadCounter) === 0) {
                analyticEvents = [];
                return;
              }

              for (var i = 0; i < uniqueEvents.length; i++) {
                $analytics.eventTrack("selectRoofPaint", {
                  eventType: "passive",
                  category: uniqueEvents[i].description,
                });
              }

              analyticEvents = [];
            }, submitAnalyticTimeout);
          }

          $scope.$watchGroup(["driveawayPrice.loading"], function () {
            if ($scope.driveawayPrice.loading) {
              $scope.rangeSpinner.showDriveawayLoadingOverlay = true;
              DebugLogger.log(
                "tyRangeSpinner",
                "showDriveawayLoadingOverlay just changed to true"
              );
            }

            triggerOnLoadedHandlerIfLoadingComplete();
          });

          function triggerOnLoadedHandlerIfLoadingComplete() {
            if (!$scope.driveawayPrice.loading) {
              $scope.rangeSpinner.showDriveawayLoadingOverlay = false;
              DebugLogger.log(
                "tyRangeSpinner",
                "showDriveawayLoadingOverlay just changed to false"
              );
              DebugLogger.log(
                "tyRangeSpinner",
                "Calling tyRangeSpinner.onRangeSpinnerLoaded"
              );
              ctl.onRangeSpinnerLoaded($scope);
            }
          }

          ctl.setGradeById = function (gradeId) {
            // Temporarily sets `isGradeUpdated` to true to block passive roof paint triggering
            $scope.rangeSpinner.isGradeUpdated = true;
            setTimeout(function () {
              $scope.rangeSpinner.isGradeUpdated = false;
              $scope.$digest();
            }, submitAnalyticTimeout);
            DebugLogger.log("tyRangeSpinner", "setGradeById(", gradeId, ")");
            $scope.rangeSpinner.gradeId = gradeId;

            $scope.rangeSpinner.grade = $scope.rangeSpinner.grades.find(
              function (grade) {
                return grade.id === $scope.rangeSpinner.gradeId;
              }
            );

            // Mock description
            var enableMockDescription = false;
            if (
              enableMockDescription &&
              !$scope.rangeSpinner.grade.description
            ) {
              $scope.rangeSpinner.grade.description =
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.";
            }

            if (!$scope.rangeSpinner.grade) {
              DebugLogger.log(
                "tyRangeSpinner",
                "setGradeById aborting (no grade found with gradeId = ",
                gradeId,
                ")"
              );
              return;
            }

            updateBodyPaints($scope.rangeSpinner.grade.paints);
          };

          ctl.setBodyPaintById = function (bodyPaintId) {
            DebugLogger.log("tyRangeSpinner", "setBodyPaintById", bodyPaintId);

            var bodyPaint = bodyPaintId ? getBodyPaintById(bodyPaintId) : null;
            $scope.rangeSpinner.bodyPaintId = bodyPaint ? bodyPaint.id : null;

            var roofPaints = getRoofPaintsByBodyPaintId(bodyPaintId);

            updateRoofPaints(roofPaints);
          };

          ctl.setRoofPaintById = function (roofPaintId) {
            DebugLogger.log(
              "tyRangeSpinner",
              "setRoofPaintById(",
              roofPaintId,
              ")"
            );

            var roofPaint = roofPaintId ? getRoofPaintById(roofPaintId) : null;
            $scope.rangeSpinner.roofPaintId = roofPaint ? roofPaint.id : null;
            $scope.rangeSpinner.materialCode = roofPaint
              ? roofPaint.materialCode
              : null;
            $scope.rangeSpinner.usageType = roofPaint
              ? $scope.rangeSpinner.grade.usageType
              : null;

            setDriveawayPriceMaterialCode(
              $scope.rangeSpinner.materialCode,
              $scope.rangeSpinner.usageType
            );
          };

          function setDriveawayPriceMaterialCode(materialCode, usageType) {
            // nothing to do
            if ($scope.driveawayPrice.materialCode === materialCode) {
              DebugLogger.log(
                "tyRangeSpinner",
                "setDriveawayPriceMaterialCode: nothing to do -- material code is not changed"
              );
              triggerOnLoadedHandlerIfLoadingComplete();
              return;
            }

            DebugLogger.log(
              "tyRangeSpinner",
              "setDriveawayPriceMaterialCode: Changing driveawayPrice.materialCode to",
              materialCode
            );

            $scope.driveawayPrice.materialCode = materialCode;
            $scope.driveawayPrice.usageType = usageType;
            $scope.driveawayPrice.hideDriveawayPrice =
              $scope.rangeSpinner.grade.hideDriveawayPrice;
            $scope.driveawayPrice.fetchPrice().finally(function () {
              triggerOnLoadedHandlerIfLoadingComplete();
            });
          }

          ctl.setAndSaveBodyPaintById = function (bodyPaintId) {
            $scope.rangeSpinner.bodyPaintId = bodyPaintId;
            $scope.rangeSpinner.savedBodyPaintId = bodyPaintId;
          };

          ctl.setAndSaveRoofPaintById = function (roofPaintId) {
            $scope.rangeSpinner.roofPaintId = roofPaintId;
            $scope.rangeSpinner.savedRoofPaintId = roofPaintId;
          };
        },
      ];

      var link = function ($scope, $element, $attrs, $ctrl) {
        $ctrl.onRangeSpinnerLoaded = $parse($attrs.tyRangeSpinnerOnLoaded);

        DebugLogger.log(
          "tyRangeSpinner",
          "link: About to set gradeId for the first time"
        );

        if ($scope.rangeSpinner.grades.length > 0) {
          $ctrl.setGradeById($scope.rangeSpinner.grades[0].id);

          DebugLogger.log(
            "tyRangeSpinner",
            "link: About to set savedRoofPaintId"
          );
          $ctrl.setAndSaveRoofPaintById($scope.rangeSpinner.roofPaintId);
          DebugLogger.log(
            "tyRangeSpinner",
            "link: savedRoofPaintId set to ",
            $scope.rangeSpinner.savedRoofPaintId
          );
        }
      };

      return {
        bindToController: {
          tyRangeSpinnerGoalId: "@tyRangeSpinnerGoalId",
          tyRangeSpinnerModelName: "@tyRangeSpinnerModelName",
        },
        scope: true,
        restrict: "A",
        controller: controller,
        controllerAs: "tyRangeSpinner",
        link: link,
      };
    },
  ]);
})(window.angular);
